import React from 'react';
import {
	Grid,
	TextField,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
	IconButton,
} from '@mui/material';
import { Delete } from '@mui/icons-material';

const SectionNamesEditable = ({
	section,
	handleUpdateElement,
	handleDeleteElement,
	handleAddElement,
}) => {
	const handleKeyDown = (event, elementIndex) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			if (section.elements.length > elementIndex + 1) {
				document.getElementById(`element-${section.id}-${elementIndex + 1}`).focus();
			} else {
				handleAddElement();
				setTimeout(() => {
					const newElementIndex = elementIndex + 1;
					document.getElementById(`element-${section.id}-${newElementIndex}`).focus();
				}, 0);
			}
		}
	};

	return (
		<Grid item xs={12}>
			{section.elements.map((element, elementIndex) => (
				<ListItem key={elementIndex}>
					<ListItemText>
						<TextField
							label="Element"
							value={element.label}
							onChange={(e) => handleUpdateElement(elementIndex, e.target.value)}
							onKeyDown={(e) => handleKeyDown(e, elementIndex)}
							fullWidth
							id={`element-${section.id}-${elementIndex}`}
						/>
					</ListItemText>
					<ListItemSecondaryAction>
						<IconButton
							onClick={() => handleDeleteElement(elementIndex)}
							aria-label="Delete Element"
							tabIndex="-1">
							<Delete />
						</IconButton>
					</ListItemSecondaryAction>
				</ListItem>
			))}
		</Grid>
	);
};

export default SectionNamesEditable;
